import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import gql from 'graphql-tag';

export const fetchCategoriesQuery = gql`
  query SearchCategories {
    taxonomy_category {
      id
      mdm_code
      mdm_name
    }
    defaultCatalog: taxonomy_category(where: { is_actived: { _eq: true } }) {
      id
      mdm_code
      mdm_name
    }
  }
`;

const category = {
  namespaced: true,
  state: {
    categories: [],
  },
  actions: {
    async fecthAll({ commit }) {
      try {
        const requestQuery = {
          query: fetchCategoriesQuery,
        };

        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_CATEGORIES', result.data);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
  },
  mutations: {
    SET_CATEGORIES(state, data) {
      Vue.set(state, 'categories', data.taxonomy_category);
    },
  },
  getters: {
    categoriesInfo: state => state.categories,
  },
};

export default category;



// WEBPACK FOOTER //
// ./src/store/modules/core/category.js